import { MadTracker } from "@madhive/mad-tracker";
import { User as MadSDKUser } from "@madhive/mad-sdk";

import { DATE_OF_CURRENT_RELEASE, __PROD__ } from "lib/constants/config";
import { REACT_APP_GIT_COMMIT } from "lib/viteEnvConfig";

import { FirebaseAnayltics, Segment } from "./listeners";

const madTracker = new MadTracker<
  MadSDKUser,
  {
    [key: string]: string;
  }
>();

if (__PROD__) {
  madTracker.listeners.register("firebase-analytics", new FirebaseAnayltics());
}

madTracker.listeners.register("segment", new Segment());

madTracker.core = {
  release_date: DATE_OF_CURRENT_RELEASE.toISOString(),
  release_commit: `${REACT_APP_GIT_COMMIT}`
};

export { madTracker };
